import Vue from "vue"
import utilsApi from "../../api/utils"

import { digger } from "../../utils/utils"

const initialObject = {
  name: undefined,
  _id: undefined,
  short_description: undefined,
  description: undefined,
  price: { USD: undefined, COP: undefined, EUR: undefined },
  original_price: { USD: undefined, COP: undefined, EUR: undefined },
  featured_media: undefined,
  media: undefined,
  tax_status: undefined,
  tax_class: undefined,
  available: undefined,
  sku: undefined,
  stock_status: undefined,
  stock_preorder: undefined,
  stock_quantity: undefined,
  stock_notification_threshold: undefined,
  weight: undefined,
  length: undefined,
  width: undefined,
  height: undefined,
  site: undefined,
  shippingType: undefined,
  shipping_class: undefined,
  notes: undefined,
  shipping_box: undefined,
  max_item_box: undefined,
  related_products: undefined,
  attributes: [],
  status: undefined,
  product: undefined,
  packaging: [],
  createdAt: undefined,
  updatedAt: undefined,
  variant_order: undefined,
  product_variant: undefined,
  sale_price: false
}

const ignoreObjectsFields = ["createdAt", "updatedAt"]

const initialState = {
  product_variants: [],
  fetched: false,
  error: false,
  object: initialObject
}
// general state for the site
const state = Object.assign({}, initialState)

const getters = {
  product_variants: (state) => state.product_variants,
  product_variantsIndex: (state) => (payload) => {
    //console.log("CHECKING INDEX", payload)
    return digger(state, payload)
    /* const { param, parent, key } = payload || {}
    return payload
      ? param
        ? key
          ? parent
            ? state[param] && state[param][parent] && state[param][parent][key]
              ? state[param][parent][key]
              : undefined
            : state[param] && state[param][key]
            ? state[param][key]
            : undefined
          : state[param]
          ? state[param]
          : undefined
        : state
      : state */
  },
  product_variantsError: (state) => state.error,
  product_variants_Object: (state) => state.object,
  product_variants_dataShape: (state) => state.dataShape
}
const actions = {
  async DELETE_product_variants({ commit, dispatch }, object) {
    let apiResponse = await utilsApi.deleteObject("product-variants", object)

    if (apiResponse != null) {
      dispatch("REMOVE_VARIATION_products", object)
      //dispatch("UPDATE_products", {})

      return true
    } else {
      commit("PRODUCTVARIANTS_ERROR")
      return false
    }
  },
  UPDATE_product_variantsState({ commit }, payload) {
    commit("SET_product_variants", payload)
    return true
  },
  async UPDATE_product_variants({ rootGetters, commit, dispatch }, object) {
    //console.log("ROOT", rootGetters.products_Object)
    commit("SET_OBJECT_VARIATION_PRODUCT", {
      productId: rootGetters.products_Object._id,
      siteId: rootGetters.site._id
    })

    let filtered = Object.keys(object)
      .filter((key) => !ignoreObjectsFields.includes(key))
      .reduce((obj, key) => {
        obj[key] = object[key]
        return obj
      }, {})

    let apiResponse = await utilsApi.updateObject("product-variants", filtered)
    if (apiResponse != null) {
      dispatch("UPDATE_OBJECT_VARIATION_products", apiResponse.product_variant)
      commit("SET_OBJECT_VARIATION", apiResponse.product_variant)

      return true
    } else {
      commit("PRODUCTVARIANTS_ERROR")
      return false
    }
  },
  async CREATE_product_variants({ commit, dispatch }, object) {
    let apiResponse = await utilsApi.createObject("product-variants", object)
    //console.log("variacion creada", apiResponse)
    if (apiResponse != null) {
      commit("SET_product_variants", {
        param: "product_variant",
        value: apiResponse.product_variant
      })
      commit("ADD_VARIATION_NEW", apiResponse.product_variant)
      dispatch("FETCH_PAGE_products", 1)
      return true
    } else {
      commit("PRODUCTVARIANTS_ERROR")
      return false
    }
  },
  async FETCH_product_variants({ commit }) {
    let apiResponse = await utilsApi.getObjects("product-variants")
    //console.log("apiResponse", apiResponse)
    if (apiResponse != null) {
      commit("PRODUCTVARIANTS_SETTING", apiResponse)
      return true
    } else {
      commit("PRODUCTVARIANTS_ERROR")
      return false
    }
  },
  UPDATE_OBJECT_product_variants({ commit }, payload) {
    commit("SET_OBJECT_VARIATION_INITIAL")
    commit("SET_OBJECT_VARIATION", payload)
    return true
  },
  UPDATE_OBJECT_product_variants_product({ rootGetters, commit }) {
    commit("SET_OBJECT_VARIATION_PRODUCT", {
      productId: rootGetters.products_Object._id,
      siteId: rootGetters.site._id
    })
    return true
  },

  CLEAN_OBJECT_product_variants({ commit }) {
    commit("SET_OBJECT_VARIATION_INITIAL")
    return true
  },
  async CLEAN_STORE_product_variants({ commit }) {
    const initialStateKeys = Object.keys(initialState)

    await Promise.all(
      initialStateKeys.map(async (current) => {
        await commit("SET_product_variants", {
          param: current,
          value: initialState[current]
        })
        return true
      })
    )

    return true
  }
}
const mutations = {
  PRODUCTVARIANTS_SETTING: (state, { product_variants }) => {
    //console.log(state)
    state.product_variants = product_variants
    state.fetched = true
    state.error = false
  },
  PRODUCTVARIANTS_ERROR: (state) => {
    state.product_variants = null
    state.fetched = true
    state.error = false

    state.dataShape = []
  },
  SET_OBJECT_VARIATION: (state, payload) => {
    //console.log("PAYLOAD OBJECT VARIATION", payload)
    Object.keys(initialObject).map((key) => {
      Vue.set(state.object, key, payload[key])
    })
  },
  SET_OBJECT_VARIATION_PRODUCT: (state, { productId, siteId }) => {
    Vue.set(state.object, "site", siteId)
    Vue.set(state.object, "product", productId)
  },
  /* SET_OBJECT_VARIATION_PRODUCT: (state, payload) => {
    const variantDB = payload.product_variants[0]
    const nObject = Object.assign({}, state.object, {
      site: variantDB.site,
      product: variantDB.product,
      _id: variantDB._id
    })
    //console.log("¨NEW OBJECT", nObject)

    state.object = nObject
  }, */
  SET_OBJECT_VARIATION_INITIAL: (state) => {
    state.object = { ...state.object, ...initialObject }
  },
  SET_product_variants: (state, payload) => {
    const { param, parent, key, value } = payload
    //console.log("SETTING FORMS STATE IN", param, value, key, parent)
    key
      ? parent
        ? state[param]
          ? state[param][parent]
            ? Vue.set(state[param][parent], key, value)
            : Vue.set(state[param], parent, {}) &&
              Vue.set(state[param][parent], key, value)
          : Vue.set(state, param, {}) &&
            Vue.set(state[param], parent, {}) &&
            Vue.set(state[param][parent], key, value)
        : state[param]
        ? Vue.set(state[param], key, value)
        : Vue.set(state, param, {}) && Vue.set(state[param], key, value)
      : Vue.set(state, param, value)
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
